import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MontoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MONTO' htmlFor='number-monto' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='monto'>
          {({ field }) => <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='number-monto' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoFormGroup)
